import { render, staticRenderFns } from "./topicList.vue?vue&type=template&id=d86098e6&scoped=true&"
import script from "./topicList.vue?vue&type=script&lang=js&"
export * from "./topicList.vue?vue&type=script&lang=js&"
import style0 from "./topicList.vue?vue&type=style&index=0&id=d86098e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86098e6",
  null
  
)

export default component.exports